import { DateTime } from 'luxon';
import { ModelEventoDTO } from 'shell/models/act-category-list';
import { AccordionEditDataControlPerson } from 'shell/view-models/edit-data-control-person';

export const transformEditDataControl = (
  modelEventoDTO: ModelEventoDTO
): AccordionEditDataControlPerson => {
  return {
    dateValidity: modelEventoDTO.datiEventoMatrimonio?.dataEvento
      ? DateTime.fromISO(modelEventoDTO.datiEventoMatrimonio?.dataEvento)
      : DateTime.now(),
  };
};
